// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AppSearch_wrapper__2IGJx"};